import { Injectable, TemplateRef, signal } from '@angular/core';
import { Subject } from 'rxjs';
import { AvailableProduct, SubscriptionItem, SubscriptionItemLocation } from '../model/subscription-billing';

export type DrawerContentType = 'add-subscription-item' | 'invoice-detail' | 'custom';

export interface DrawerConfig {
  type: DrawerContentType;
  title: string;
  data?: any;
  template?: TemplateRef<any>;
}

export interface DrawerResult {
  type: DrawerContentType;
  success: boolean;
  data?: any;
}

@Injectable({
  providedIn: 'root'
})
export class BusinessDetailDrawerService {
  // signals: the app shell binds these in its template, and open() is often called after an HTTP
  // response, where nothing else would schedule a render under zoneless
  readonly isOpen = signal(false);
  readonly config = signal<DrawerConfig | null>(null);
  private resultSubject = new Subject<DrawerResult>();
  readonly result$ = this.resultSubject.asObservable();

  open(config: DrawerConfig): void {
    this.config.set(config);
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
    // Clear config after animation completes
    setTimeout(() => this.config.set(null), 300);
  }

  // Close with result (success or failure)
  closeWithResult(result: DrawerResult): void {
    this.resultSubject.next(result);
    this.close();
  }

  // Convenience method for opening add subscription item drawer
  openAddSubscriptionItem(data: {
    businessId: string;
    availableProducts: AvailableProduct[];
    billingCycle: 'MONTHLY' | 'YEARLY';
    locations: SubscriptionItemLocation[];
    subscriptionItems: SubscriptionItem[];
    multiLocationEnabled: boolean;
  }): void {
    this.open({
      type: 'add-subscription-item',
      title: 'Add Product',
      data
    });
  }

  // Convenience method for opening invoice detail drawer
  openInvoiceDetail(invoice: any): void {
    this.open({
      type: 'invoice-detail',
      title: invoice.invoiceNumber,
      data: { invoice }
    });
  }
}